module.exports = __webpack_public_path__ + "img/josh_mullet_sadones.657aa74d.png";